module.exports = __webpack_public_path__ + "static/media/mobile-image-4.21990e55.png";